module.exports = __webpack_public_path__ + "3c994dc8d328f02770abc981760188a1.jpg";